module.exports = __webpack_public_path__ + "static/media/corporateStep4.85f94063.svg";